import styled from 'styled-components';

export const SidebarWrapper = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  background: #f4f5f7;
  color: #444;
  position: relative;
  padding-top: 0;
  display: ${({ isEmbeddedMobile }) => (isEmbeddedMobile ? 'none' : 'flex')};
  flex-flow: row nowrap;
  align-items: stretch;
  box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.26);
`;

export const ComponentWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  overflow-y: auto;
  position: relative;
`;

export const Title = styled.span`
  transform: rotate(180deg);
  text-transform: uppercase;
  font-size: 18px;
  font-weight: 600;
  writing-mode: tb-rl;
  color: #444;
  display: flex;
  align-items: center;
`;
